let current_business;

/**
 * Show modal info using search form as proxy
 * @param event
 * @param searchForm {jQuery}
 * @param phrase {String}
 */

window.onhashchange = function (ev) {
  var hash = location.hash;
  if (hash) {
    hash = hash.slice(1);
    hash = decodeURIComponent(hash);
    $('input[name="q"]').val(hash);

    var s_f = $("#search-form");
    if (s_f.length) {
      showFormChoiceModal(ev, s_f, hash);
    }
  }
};

function checkAvailabilityAction(phrase, onLandingPage = false) {
  if (phrase) {
    showElasticModal({ q: phrase }, onLandingPage);
  } else {
    toggleErrorHandler(true);
  }
}

function fetchElasticForms(url, onLandingPage = false) {
  const top_category_container = $("#organize-party-modal .top-category");

  $.get(url).done((res) => {
    let categories = [];

    const leisureCategoryBtnClass = onLandingPage
      ? "landing-page-elastic-phrase"
      : "elastic-phrase";

    res.forEach(function (category) {
      categories.push(`
            <li class="top-category__item">
                <button type="button" class="leisure-category-btn ${leisureCategoryBtnClass}"
                        data-phrase="${category.name}">${category.name}</button>
            </li>
        `);
    });
    categories.push(`
            <li class="top-category__item">
                <label>
                    <input class="leisure-category-search" type="text" name="leisure_category_search" 
                        placeholder="Inna impreza - wpisz np. kolacja" autocomplete="off">
                </label>
            </li>
        `);
    top_category_container.html(categories.join("")).end();

    $("#organize-party-modal .leisure-category-search").on(
      "keypress",
      (event) => {
        if (event.which === 13) {
          const inputValue = $(event.target).val();
          checkAvailabilityAction(inputValue, onLandingPage);
        }
      }
    );

    // todo - error handler

    function toggleErrorHandler(show = true) {
      const errorHandler = document.querySelector(
        "#organize-party-modal .modal-body__error"
      );
      if (errorHandler) {
        errorHandler.style.display = show ? "block" : "none";
      }
    }

    toggleErrorHandler(false);

    organizePartyModal.modal({
      show: true,
      backdrop: "static",
    });

    setTimeout(() => {
      $("body").addClass("modal-open");
    }, 1000);
  });
}

function showPopularForms(onLandingPage = false) {
  fetchElasticForms(popular_forms_endpoint_url, onLandingPage);
}

function showElasticModal(data, onLandingPage = false) {
  function renderElasticCategories(html) {
    elasticModal.find("#elastic-body").html(html.body).end();
    if (html.title) {
      elasticModal.find(".modal-title").first().html(html.title).end();
      elasticModal.find(".modal-title").removeClass("hidden");
    }
    elasticModal.find(".modal-footer").addClass("hidden").end(); // hide prev-next buttons
  }

  $.get(forms_endpoint_url, data).done(function (res) {
    // remove ajax-wait icon from search button
    $(".button-search.ajax-wait").removeClass("ajax-wait");

    if (res.success === false) {
      throw Error("Elasticforms response failed! " + res);
    }

    availableForms = res; // assign to outer scope

    if (res.length === 0) {
      elasticModal.find(".modal-title").addClass("hidden");

      organizePartyModal
        .find(".modal-body__header")
        .html("Niestety nie znamy jeszcze takiej okazji");
      organizePartyModal
        .find(".modal-body__subheader")
        .html(
          'Rozważ jedną z popularnych okazji lub wpisz inną i kliknij "Dalej"'
        );
      showPopularForms(onLandingPage);
      return;
    }
    organizePartyModal.modal("hide");
    let forms = [`<div class="list-group hidden">`];

    for (let i = 0; i < res.length; i += 1) {
      forms.push(`<button type="button"
                            class="list-group-item btn-elasticform"
                            data-form="${i}">${res[i].name}</button>`);
    }
    forms.push(`</div>`);
    renderElasticCategories({
      body: forms.join(""),
      title: "Wybierz interesującą Cię okazję",
    });

    // check if there is only one rendered categories
    // if yes trigger click event to move directly to form
    let categories = $(".btn-elasticform");

    if (categories.length === 1) {
      elasticModal.autoChoose = true;
      categories[0].click();
    }
    elasticModal.find(".list-group").removeClass("hidden");
    elasticModal.modal({
      show: true,
      backdrop: "static", // avoid accidental modal escape
    });
  });
}

function showFormChoiceModal(event, form, phrase) {
  resizeModal();

  // update phrase in form
  form.find('input[name="q"]').val(phrase);
  //noinspection JSUnresolvedVariable
  let data = form.serialize();

  if (event) {
    event.preventDefault();
  }

  elasticModal.find(".progress").addClass("hidden");
  elasticModal.find(".modal-title").removeClass("hidden");

  if ($.trim(form.find('input[name="q"]').val()).length == 0) {
    organizePartyModal
      .find(".modal-body__header")
      .html("Co chcesz zorganizować w lokalu?");
    organizePartyModal
      .find(".modal-body__subheader")
      .html(
        'Kliknij na jedną z popularnych okazji lub wpisz swoją i kliknij "Dalej"'
      );

    showPopularForms();
    return;
  }

  // start submit form - set ajax-wait icon
  if (!$(".button-search").hasClass("ajax-wait")) {
    $(".button-search").addClass("ajax-wait");
  }

  showElasticModal(data);
}

function elasticFormChoiceHandler(event) {
  event.preventDefault();

  elasticModal.find(".progress").removeClass("hidden");
  elasticModal.find(".modal-title").addClass("hidden");

  let form = availableForms[$(event.currentTarget).data("form")];

  /**
   * Create and initialize elastic form
   *
   * If there is autoChoose options enabled wait till modal has been shown
   * then render elastic form
   * else render form immediately
   */
  if (elasticModal.autoChoose === true) {
    elasticModal.one("shown.bs.modal", function (event) {
      window.elasticform = new ElasticForm(
        form,
        configuration.elasticforms,
        current_business
      );
      window.elasticform.init();
      // $(this).off(event);
    });
  } else {
    window.elasticform = new ElasticForm(
      form,
      configuration.elasticforms,
      current_business
    );
    window.elasticform.init();
  }

  /**
   * Destroy current visible elastic form
   */
  elasticModal.on("hide.bs.modal", function () {
    try {
      window.elasticform.destructor();
      window.elasticform = undefined;
    } catch (err) {
      /* skip not relevant */
    }
  });

  availableForms = undefined;
  elasticModal.autoChoose = false;
  elasticModal.find(".modal-footer").removeClass("hidden"); // show prev-next buttons
  elasticModal.find("input:first").focus(); // try to set focus on first input
}

let forms_endpoint_url = configuration.elasticforms.forms_endpoint,
  reply_endpoint_url = configuration.elasticforms.reply_endpoint,
  popular_forms_endpoint_url = configuration.home_page.popular_forms_endpoint,
  availableForms,
  elasticModal = $("#elastic-modal"),
  elasticSearch = $("#search-form"),
  barSlider = $(".elastic-group"),
  organizePartyModal = $("#organize-party-modal");

elasticSearch.on("submit", function (event) {
  showFormChoiceModal(
    event,
    elasticSearch,
    elasticSearch.find('input[name="q"]').val()
  );
}); // fetch forms

const scrollTimer = 1000;
const scrollTopOffset = 10;

elasticSearch.on("touchstart", function () {
  $([document.documentElement, document.body]).animate(
    {
      scrollTop: elasticSearch.offset().top - scrollTopOffset,
    },
    scrollTimer
  );
});

elasticModal.on("click", ".btn-elasticform", elasticFormChoiceHandler); // choice form
barSlider.on("click", ".elastic-phrase", function (event) {
  "use strict";
  let btn = $(event.currentTarget),
    phrase = btn.data("phrase");
  showFormChoiceModal(event, elasticSearch, phrase);
});

barSlider.on("click", ".landing-page-elastic-phrase", function (event) {
  "use strict";
  let btn = $(event.currentTarget),
    phrase = btn.data("phrase");
  fakeShowFormChoiceModal(event, phrase);
});

const popularOpportunities = "Popularne okazje";

new autoComplete({
  selector: 'input[name="q"]',
  minChars: 0,
  source: function (term, render) {
    "use strict";
    if (term) {
      // show forms mtching entered query
      $.get(forms_endpoint_url, { q: term }, function (res) {
        let hints = res.map(function (element) {
          return element.name;
        });

        render(hints);
      });
    } else {
      // show popular forms
      $.get(popular_forms_endpoint_url, {}, function (res) {
        let hints = res.map(function (element) {
          return element.name;
        });
        if (hints.length) {
          render([popularOpportunities, ...hints]);
        }
      });
    }
  },
  renderItem: function (item, search) {
    // escape special characters
    search = search.replace(/[-\/\\^$*+?.()|[\]{}]/g, "\\$&");
    let re = new RegExp("(" + search.split(" ").join("|") + ")", "gi");
    let value = "";

    if (item === popularOpportunities) {
      value =
        '<div class="autocomplete-header" data-val="' +
        item +
        '">' +
        item +
        "</div>";
    } else {
      value =
        '<div class="autocomplete-suggestion" data-val="' +
        item +
        '">' +
        item.replace(re, "<b>$1</b>") +
        "</div>";
    }

    return value;
  },
  onSelect: function (e, term, item) {
    elasticSearch.trigger("autocompleteselect", [term]);
    showFormChoiceModal(e, elasticSearch, term);
  },
});

function toggleErrorHandler(show = true) {
  const errorHandler = document.querySelector(
    "#organize-party-modal .modal-body__error"
  );
  if (errorHandler) {
    errorHandler.style.display = show ? "block" : "none";
  }
}

organizePartyModal.on("click", "#party-next-btn", function (event) {
  const searchBar = event.target.parentElement.parentElement.querySelector(
    ".leisure-category-search"
  );
  const data = searchBar.value.trim();

  checkAvailabilityAction(data);
});

organizePartyModal.on("click", "#party-next-landing-page-btn", function (event) {
  const searchBar = event.target.parentElement.parentElement.querySelector(
    ".leisure-category-search"
  );
  const data = searchBar.value.trim();

  checkAvailabilityAction(data, true);
});

$(document).ready(function () {
  $(window).trigger("hashchange");
});
